import { createFileRoute, notFound } from "@tanstack/react-router";
import { normalizeDesignSystemSearch } from "~/features/design-system/search";

const DESIGN_SYSTEM_DESCRIPTION =
  "Living reference for the Glider design system: tokens, components, patterns, and the rules that bind them.";
const DESIGN_SYSTEM_TITLE = "Design System | Glider";

export const Route = createFileRoute("/design-system")({
  beforeLoad: () => {
    if (!(import.meta.env.DEV || import.meta.env.MODE === "test")) {
      throw notFound();
    }
  },
  head: () => ({
    meta: [
      { title: DESIGN_SYSTEM_TITLE },
      { content: DESIGN_SYSTEM_DESCRIPTION, name: "description" },
      { content: DESIGN_SYSTEM_TITLE, property: "og:title" },
      { content: DESIGN_SYSTEM_DESCRIPTION, property: "og:description" },
      { content: "noindex, nofollow", name: "robots" },
      { content: "summary", name: "twitter:card" },
      { content: DESIGN_SYSTEM_TITLE, name: "twitter:title" },
      { content: DESIGN_SYSTEM_DESCRIPTION, name: "twitter:description" },
    ],
  }),
  validateSearch: (raw) => normalizeDesignSystemSearch(raw),
});
